import React, { useState, useEffect } from "react";
import { Box, styled } from "@mui/material";
import { useRouteMatch } from "react-router-dom";
import user_not_logged_in_icon from "../../../img/user_not_logged_in_icon.svg";
import { RegisterSidebar } from "../../sidebars/register-sidebar/register-sidebar";
import { useSidebarStore } from "../../../store/sidebarStore";
import { createPortal } from "react-dom";

// Custom styled components using MUI
const Container = styled(Box)({
  position: "fixed",
  right: 0,
  top: "23px",
  zIndex: 13,
  userSelect: "none",
});

const StyledMenuIcon = styled(Box)(({ theme }) => ({
  marginRight: "20px",
  marginLeft: "10px",
  cursor: "pointer",
  paddingLeft: "20px",
  paddingRight: "10px",
  userSelect: "none",
  position: "relative",
  color: "black",
  [`@media only screen and (max-width: ${theme.xsDevicesBreakpoint})`]: {
    marginRight: "10px",
  },
}));

export const LoginButton = ({ position }) => {
  const match = useRouteMatch();

  const { setLoginSidebarOpen: setIsLoginSidebarOpen } = useSidebarStore();

  const [isRegisterMenuOpen, setIsRegisterMenuOpen] = useState(
    match.path === "/registration"
  );

  useEffect(() => {
    setIsRegisterMenuOpen(match.path === "/registration");
  }, [match.path]);

  return (
    <Container sx={{ position: position || "fixed" }}>
      <StyledMenuIcon
        component="img"
        src={user_not_logged_in_icon}
        fontSize={"large"}
        onClick={() => {
          setIsLoginSidebarOpen(true);
        }}
        data-testid="login-sidebar-button-icon"
      />

      {createPortal(
        <RegisterSidebar
          isOpen={isRegisterMenuOpen}
          setIsOpen={setIsRegisterMenuOpen}
        />,
        document.body
      )}
    </Container>
  );
};
